import Button from "../button/button.component";
import noImage from "../../assets/images/No_Image_Available.jpg"
import "./eventCard.styles.jsx"
import { EventCardStyled } from "./eventCard.styles.jsx";
import moment from "moment";

const EventCard = ({detailed, buttonType, link, adventure}) => {
    return (
      <>
        <EventCardStyled detailed={detailed}>
          <div className="event-card__image">
            <a href={link} target="_top">
              {adventure?.displayImage ? (
                <img
                  src={`${adventure.displayImage}`}
                  alt="event"
                  className="w-full h-full object-fill"
                ></img>
              ) : (
                <img src={noImage} alt="event"></img>
              )}
            </a>
          </div>
          <p className="event-card__tags">
            {adventure?.isChildFriendly ? (
              <span className="event-card__tag">child friendly</span>
            ) : (
              ""
            )}
            <span className="event-card__tag">{adventure?.difficultyLabel}</span>
            <span className="event-card__tag">{adventure?.typeLabel}</span>
          </p>
          <div className="event-card__description">
            <p className="event-card__location">
              <i className="fa-solid fa-location-dot"></i> {adventure?.location}
              , {adventure?.country}
            </p>
            <h3 className="event-card__name" title={adventure?.name}>
              {adventure?.name}
            </h3>
            <p className="event-card__date">
              {moment(adventure?.startDate).format("MMMM DD, YYYY")}
            </p>
            <p className="event-card__price u-margin-top-tiny">
              From Ksh {adventure?.minimumPrice} per head
            </p>
            <div className="event-card__button u-margin-top-small">
              <Button buttonType={buttonType} link={link}>
                View Event
              </Button>
            </div>
          </div>
        </EventCardStyled>
      </>
    );
}

export default EventCard;